@let obs =
  {
    items: items$ | async,
    loading: loading$ | async,
    breakpoint: deviceBreakpoint$ | async,
    title: carouselTitle$ | async,
  };

@if (obs.items && obs.items.length > 0 && obs.loading) {
  <div class="skeletons">
    @for (i of [].constructor(6); track i) {
      <sd-product-item-skeleton class="product-grid-item"></sd-product-item-skeleton>
    }
  </div>
} @else if (obs.items && obs.items.length > 0 && !obs.loading) {
  <div
    class="carousel carousel-{{ obs.breakpoint }}"
    [ngClass]="{ 'is-ssr': isServer }"
    sdProductCardNavigation
    [sdInViewport]="0.25"
    [intersectedOnce]="true"
    (intersected)="onIntersect()"
  >
    @if (obs.title) {
      <div class="h2">{{ obs.title }}</div>
    }

    <sd-swiper
      [items]="obs.items"
      [config]="config"
      (activeIndexChange)="onIndexChange($event)"
      (slidesPerViewChange)="onSlidesPerViewChange($event)"
    >
      <ng-template #slide let-item="item">
        <div class="grid-view-mode product-carousel-item">
          <sd-product-item [product]="item"></sd-product-item>
        </div>
      </ng-template>
    </sd-swiper>
  </div>
}
